import { render, staticRenderFns } from "./CustomerBehaviorCards.vue?vue&type=template&id=1ee2246c&"
import script from "./CustomerBehaviorCards.vue?vue&type=script&lang=js&"
export * from "./CustomerBehaviorCards.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports